import { Building2, BarChart3, Wallet, ShieldCheck, Users, Cog } from 'lucide-react';
import { motion } from 'motion/react';
import MarketingLayout from './_layout';
import { cn } from '../../utils/helpers';

const services = [
  {
    icon: Building2,
    title: 'Enterprise Solutions',
    desc: 'Custom workflows, advanced security, and dedicated success managers for large organizations.',
    color: 'text-purple-600 dark:text-purple-400',
    bg: 'bg-purple-50 dark:bg-purple-950/40',
  },
  {
    icon: BarChart3,
    title: 'Market Insights',
    desc: 'Real-time data and AI-driven reports on industry trends and competitor activity.',
    color: 'text-blue-600 dark:text-blue-400',
    bg: 'bg-blue-50 dark:bg-blue-950/40',
  },
  {
    icon: Wallet,
    title: 'Financial Infrastructure',
    desc: 'Global payment processing, automated billing, and secure asset management.',
    color: 'text-emerald-600 dark:text-emerald-400',
    bg: 'bg-emerald-50 dark:bg-emerald-950/40',
  },
  {
    icon: Users,
    title: 'Talent & Hiring',
    desc: 'Source, vet, and onboard top talent through our integrated career and assessment tools.',
    color: 'text-amber-600 dark:text-amber-400',
    bg: 'bg-amber-50 dark:bg-amber-950/40',
  },
  {
    icon: ShieldCheck,
    title: 'Compliance & Risk',
    desc: 'KYC, AML, and ongoing monitoring built into every transaction across the ecosystem.',
    color: 'text-rose-600 dark:text-rose-400',
    bg: 'bg-rose-50 dark:bg-rose-950/40',
  },
  {
    icon: Cog,
    title: 'API & Integrations',
    desc: 'Embed Messego into your stack with first-class APIs, webhooks, and SDKs.',
    color: 'text-neutral-900 dark:text-neutral-50',
    bg: 'bg-neutral-100 dark:bg-neutral-800',
  },
];

export default function ServicesPage() {
  return (
    <MarketingLayout
      title="Services for every stage"
      subtitle="From solo professionals to Fortune 500 enterprises — Messego adapts to how your team works and grows."
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="bg-white dark:bg-neutral-900 p-8 rounded-[2rem] border border-neutral-200 dark:border-neutral-800 shadow-sm dark:shadow-none hover:shadow-xl hover:shadow-neutral-200/50 transition-all group"
          >
            <div className={cn('w-14 h-14 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform', s.bg, s.color)}>
              <s.icon className="w-7 h-7" />
            </div>
            <h3 className="text-xl font-bold text-neutral-900 dark:text-neutral-50 mb-3">{s.title}</h3>
            <p className="text-neutral-500 dark:text-neutral-400 text-sm leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </MarketingLayout>
  );
}
